export const LEGAL_TEXT = {
  privacy: `# Overview
Rooted Business Advisors, LLC ("Rooted," "we," "us," or "our") respects your privacy. This Privacy Policy explains what information we collect through this website, how we use it, and the choices you have.
# Information We Collect
Information you provide: when you submit a consultation request, we collect your name, email address, phone number, business name, service of interest, preferred appointment time, and the contents of your message.
Technical information: like most websites, our hosting systems may automatically collect basic technical data such as your browser type, device, and pages visited, used solely to keep the site secure and functioning.
# How We Use Your Information
We use the information you provide to respond to your inquiry, schedule and confirm consultations, and communicate with you about our services. We do not sell, rent, or trade your personal information to anyone.
# Service Providers
We use a small number of trusted service providers to operate this website and deliver email notifications. These providers process information only as needed to perform their services for us.
# Data Retention & Security
We retain consultation requests only as long as needed to manage our relationship with you and meet any legal or record-keeping obligations. We apply reasonable administrative and technical safeguards to protect your information; however, no method of transmission over the internet is completely secure.
# Your Choices
You may ask us to access, correct, or delete the personal information we hold about you at any time by contacting us using the details below.
# Changes to This Policy
We may update this Privacy Policy from time to time. The "last updated" date above reflects the most recent revision.
# Contact
Questions about this policy? Email Jennifer@RootedBusinessAdvisors.com or call (513) 288-8842.`,

  terms: `# Acceptance of Terms
By accessing or using this website, you agree to these Website Terms of Use. If you do not agree, please do not use the site.
# Informational Purposes Only
The content on this website is provided for general informational purposes. Using this website, or submitting a consultation request through it, does not create a client, advisory, fiduciary, or professional relationship between you and Rooted Business Advisors, LLC. A relationship is formed only through a signed engagement agreement.
# Appointment Requests
Dates and times requested through this website are requests only and are not guaranteed or booked until confirmed directly by Rooted.
# Intellectual Property
All content on this website — including text, design, logos, and images — is the property of Rooted Business Advisors, LLC and may not be reproduced or used without our written permission.
# Acceptable Use
You agree not to misuse this website, including by attempting to interfere with its operation, accessing areas not intended for you, or submitting false or misleading information.
# Third-Party Links
This site may contain links to third-party websites. We are not responsible for the content or practices of those sites.
# Disclaimers & Limitation of Liability
This website is provided "as is" without warranties of any kind. To the fullest extent permitted by law, Rooted Business Advisors, LLC is not liable for any damages arising from your use of, or inability to use, this website.
# Governing Law
These terms are governed by the laws of the State of Ohio, without regard to conflict-of-law principles.
# Changes & Contact
We may update these terms from time to time; the "last updated" date above reflects the latest revision. Questions? Email Jennifer@RootedBusinessAdvisors.com or call (513) 288-8842.`,

  disclaimer: `# Scope of Services
Rooted Business Advisors, LLC provides bookkeeping, financial reporting, payroll oversight, compensation consulting, and business advisory services.
Rooted is not a CPA firm, law firm, tax advisor, investment adviser, or broker-dealer, and does not provide legal, tax, investment, audit, attestation, or assurance services.
# No Professional Advice
Nothing on this website constitutes accounting, tax, legal, investment, or other professional advice. Content is general in nature and may not apply to your specific circumstances. You should consult a qualified professional — such as your CPA, attorney, or tax advisor — before acting on any information found here.
# No Client Relationship
Viewing this website or contacting us through it does not establish a client relationship. Services are provided only under a written engagement agreement that defines scope, responsibilities, and fees.
# Accuracy of Information
We work hard to keep the information on this site accurate and current, but we make no representations or warranties about completeness, reliability, or accuracy. Any reliance you place on such information is strictly at your own risk.
# Contact
Questions about this disclaimer? Email Jennifer@RootedBusinessAdvisors.com or call (513) 288-8842.`,
};

export const LEGAL_META = {
  privacy: {
    title1: "Privacy",
    title2: "Policy.",
    seoTitle: "Privacy Policy | Rooted Business Advisors",
    seoDescription: "How Rooted Business Advisors, LLC collects, uses, and protects your personal information.",
  },
  terms: {
    title1: "Website Terms",
    title2: "of Use.",
    seoTitle: "Website Terms of Use | Rooted Business Advisors",
    seoDescription: "The terms that govern your use of the Rooted Business Advisors website.",
  },
  disclaimer: {
    title1: "Professional",
    title2: "Disclaimer.",
    seoTitle: "Professional Disclaimer | Rooted Business Advisors",
    seoDescription: "The scope and limits of the professional services offered by Rooted Business Advisors, LLC.",
  },
};
